import React, { useState } from 'react';
import { IconEyeShow, IconEyeHide, IconRefreshAction } from './icons';
import './PasswordField.css';

function getStrength(pw) {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8)          score++;
  if (/[A-Z]/.test(pw))        score++;
  if (/[0-9]/.test(pw))        score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return score; // 0–4
}

function generatePassword() {
  const lower   = 'abcdefghijklmnopqrstuvwxyz';
  const upper   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const digits  = '0123456789';
  const special = '!@#$%&*';
  const all     = lower + upper + digits + special;

  const pick = (str) => {
    const a = new Uint32Array(1);
    crypto.getRandomValues(a);
    return str[a[0] % str.length];
  };

  const chars = [pick(lower), pick(upper), pick(digits), pick(special)];
  for (let i = 0; i < 12; i++) chars.push(pick(all));

  // Fisher-Yates shuffle
  const rnd = new Uint32Array(chars.length);
  crypto.getRandomValues(rnd);
  for (let i = chars.length - 1; i > 0; i--) {
    const j = rnd[i] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

const STRENGTH_LABEL = ['', 'Schwach', 'Schwach', 'Mittel', 'Stark'];
const STRENGTH_CLASS = ['', 'weak',    'weak',    'medium', 'strong'];

function PasswordField({
  id,
  value,
  onChange,
  placeholder,
  autoComplete,
  required,
  showStrength,
  showGenerator,
  onGenerate,
}) {
  const [visible, setVisible] = useState(false);

  function handleGenerate() {
    const pw = generatePassword();
    if (onGenerate) {
      onGenerate(pw);
    } else {
      onChange({ target: { value: pw } });
    }
    setVisible(true);
  }

  const strength = showStrength ? getStrength(value) : 0;

  return (
    <div className="pw-field-wrap">
      <div className="pw-input-row">
        <input
          id={id}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
        />
        {showGenerator && (
          <button type="button" className="pw-icon-btn pw-gen-btn" onClick={handleGenerate} title="Sicheres Passwort vorschlagen">
            <IconRefreshAction size={16} />
          </button>
        )}
        <button type="button" className="pw-icon-btn pw-eye-btn" onClick={() => setVisible(v => !v)} title={visible ? 'Verbergen' : 'Anzeigen'}>
          {visible ? <IconEyeHide size={16} /> : <IconEyeShow size={16} />}
        </button>
      </div>
      {showStrength && value && (
        <div className="pw-strength">
          <div className="pw-strength-bar">
            <div className={`pw-strength-fill pw-s-${STRENGTH_CLASS[strength]}`} style={{ width: `${strength * 25}%` }} />
          </div>
          <span className={`pw-strength-label pw-sl-${STRENGTH_CLASS[strength]}`}>
            {STRENGTH_LABEL[strength]}
          </span>
        </div>
      )}
    </div>
  );
}

export default PasswordField;
